import { request } from '../request';

const index = {
  // 首页block配置
  indexBlock: (data, config) => request('/api/block/block', 'get', data, config), // 首页配置
  getBlockByUrlSuffix: (data, config) =>
    request('/api/subject/getBlockByUrlSuffix', 'get', data, config), // 自定义专题页配置
  homePageBlock: (data) => request('/api/block/block_index', 'get', data), // 首页专用配置（在indexBlock基础上由后端做过字段过滤）
  homeBlock: (data, config = {}) => request('/api/block/home_index', 'get', data, config), // 首页专用配置（在indexBlock基础上由后端做过字段过滤）

  // 评价接口
  trustpilot: (data) => request('/api/block/trustpilot', 'get', data), // 三方评价接口
};
export default index;
